<div class="icon-snackbar">
  <mat-icon class="icon-snackbar__icon">{{ data.icon }}</mat-icon>
  <span class="icon-snackbar__message">{{ data.message }}</span>
  <button *ngIf="data.buttonLabel" mat-button class="icon-snackbar__button" (click)="dismiss()">
    {{ data.buttonLabel }}
  </button>
</div>
